import { render } from "./LoginSlider.vue?vue&type=template&id=9879faba&scoped=true"
import script from "./LoginSlider.vue?vue&type=script&lang=js"
export * from "./LoginSlider.vue?vue&type=script&lang=js"

import "./LoginSlider.vue?vue&type=style&index=0&id=9879faba&scoped=true&lang=scss"

import exportComponent from "D:\\Projects\\Normann\\Configurator Dashboard\\normann-dashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9879faba"]])

export default __exports__